import { object, string } from "yup";
import { FormikProps, FormikActions } from "formik";

import { reduceFieldSettings, TItem } from "../../../utils/reduceFieldSettings";

const list: Array<TItem> = [
  {
    name: "email",
    type: "email",
    initValue: "",
    placeholder: "Email",
    validationRule: string()
      .email("Not valid email.")
      .required("Email is required."),
  },
  {
    name: "password",
    type: "password",
    initValue: "",
    placeholder: "Password",
    validationRule: string()
      .required("Password is required"),
  },
];

const { initialValues, fields, validationRuleObject } = reduceFieldSettings(list);

const validationSchema = object().shape(validationRuleObject);

export type ValueTypes = typeof initialValues;

export type FormTypes = FormikProps<ValueTypes>;

export type FormActionTypes = FormikActions<ValueTypes>;

export {
  fields,
  initialValues,
  validationSchema,
};
